﻿<template>
    <journey-connection-property-base :label="resource('JourneyBuilder_FilterSettings_StartDate')" forInput="ConnectionStartDate">
        <date-picker
                id="ConnectionStartDate"
                
                v-model="model"

                :options="{
                    clearButton: true,
                    clearButtonIcon: 'fas fa-times',
                    
                    required: false,
                    typeable: false,
                    
                    disabledDates: {
                        from: undefined,
                        to: new Date(0)
                    }
            }"
        />
    </journey-connection-property-base>
</template>

<script>
    import dateHelpers from '../../../../Util/date-helpers'

    import resources from '../../../../../../Util/Mixins/resources';

    import DatePicker from "../../../../../../Components/Util/DatePicker.vue";
    import JourneyConnectionPropertyBase from "./../JourneyConnectionPropertyBase.vue";


    export default {
        name: 'journey-connection-start-date',
        mixins: [resources],
        components: {
            DatePicker,
            JourneyConnectionPropertyBase
        },
        computed: {
            model: {
                get(){
                    return this.value ? dateHelpers.getDateFromString(this.value) : undefined;
                },
                set(value){
                    this.$emit('input', value ? dateHelpers.getStringifiedDate(value) : value);
                }
            }
        },
        props: {
            value: String
        }
    }
</script>